function animateRow(row) {
  row.classList.add('show');
}
const rows = document.querySelectorAll('.trigger');
const trigger = new IntersectionObserver((entries, trigger) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      animateRow(entry.target);
      trigger.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.1
});

rows.forEach(row => {
  trigger.observe(row);
});

window.kanyaariObserveTriggers = function (scope) {
  if (!scope || scope.nodeType !== 1) return;
  if (scope.matches('.trigger:not(.show)')) trigger.observe(scope);
  scope.querySelectorAll('.trigger:not(.show)').forEach(row => trigger.observe(row));
};

new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(window.kanyaariObserveTriggers);
  });
}).observe(document.body, { childList: true, subtree: true });
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'observer--cancel';
function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}
